/* eslint-disable import/first */
import React, { useState, useEffect, useContext } from 'react';
import { Grid, Paper, Typography, Divider, Button, Link, LinearProgress } from '@material-ui/core';
// import { RiRoadMapLine } from '@react-icons/all-files/ri/RiRoadMapLine';
// eslint:fix RiRoadMapLine is defined but never used
import { AiOutlineRight } from '@react-icons/all-files/ai/AiOutlineRight';
import { RiHome3Line } from '@react-icons/all-files/ri/RiHome3Line';
import { MdCall } from '@react-icons/all-files/md/MdCall';
import supportPhone from '../../components/OrderSummary/images/phonebtn.svg';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate, useLocation } from '@reach/router';
const { selectDesktop } = Slices.appSlice;
import differenceInMinutes from 'date-fns/differenceInMinutes';
const { orderStatus, sendFeedBack, getOrderDetail } = Slices.orderSlice;
const { selectLoginStatus } = Slices.authSlice;
const { removeCookieData, clearCart } = Slices.cartSlice;
import UnableProcess from '../../components/UnableProcess';
import Writeus from './Writeus';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import Header from '../../components/Header';
import LocationPin from './images/location.svg';
import statusIcon from './images/drive_thru.svg';
import locatinIcon from './images/pin.svg';
import phIcon from './images/phIcon.svg';
import OrderStatus from '../OrderStatus';
import OrderSummary from '../../components/OrderSummary';
import FeedbackForm from './../../components/FeedbackForm/index';
import StarRating from '../../components/StarRating';
import map1 from '../TrackOrderDetail/images/map1.svg';
import phoneIcon from '../TrackOrderDetail/images/call.svg';
import parking from '../TrackOrderDetail/images/parking.svg';
import delivery from '../TrackOrderDetail/images/packagedelivery.svg';
import chat from '../TrackOrderDetail/images/chat.svg';
import phn from '../TrackOrderDetail/images/phone1.svg';

const { selectCurrentCountry, getCurrentProfile } = Slices.profileSlice;
const { selectCountryValidations, selectOrderModesByCountry, selectBaseURL } = Slices.configSlice;

import DrawerPwa from '../../components/DrawerPwa';
import FeedbackInfo from '../Feedback/FeedbackInfo';
import FeedbackPopup from '../Feedback/FeedbackPopup';
const { selectStoreEntities } = Slices.storeSlice;
import { Context } from '../../components/Multi-lang/Wrapper';
import {
  orderTrackGA,
  trackingPurchaseGA,
  purchaseEventGA,
  binThankyou,
} from 'spwa-ui-library/esm/utils/helperGA';
const { couponCodeApplied } = Slices.offerSlice;
import { FormattedMessage, useIntl } from 'react-intl';
import Skelton from './Skelton';
import LanguageButton from '../../components/LanguageButton';
import css from './index.module.scss';
import DialogBox from '../../components/DialogBox';
import LightningPayStatus from '../Checkout/LightningPayStatus';
import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';

function Thankyou({ orderId }) {
  const location = useLocation();
  const { paymentCompleted, lightningPaySuccess } = location.state || {};
  const intl = useIntl();
  const order = useSelector((state) => state.order);
  const config = useSelector((state) => state.config);
  // const auth = useSelector((state) => state.auth);
  // eslint:fix auth is defined a value but never used
  const storeList = useSelector(selectStoreEntities);
  const isLogged = useSelector(selectLoginStatus);
  const profile = useSelector((state) => state.profile);
  const cartDetail = useSelector((state) => state.cart);
  const [selectedStore, setSelectedStore] = React.useState({});
  const [lightningPayStatusModal, setLightningPayStatusModal] = React.useState(lightningPaySuccess);
  const offerSelected = useSelector(couponCodeApplied);
  const imgBaseUrl = useSelector(selectBaseURL);
  const categoryList = useSelector((state) => state.category);
  const [orderInfo, setOrderInfo] = useState(order?.data?.info?.data?.orderPlaced?.orderInfo);
  const labels = config?.data?.data?.constants?.liveTrackingLabel;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // ordStatus === 'CONFIRMED' ||
  // ordStatus === 'PENDING' ||
  // ordStatus === 'FAILURE' ||
  // ordStatus === 'CANCELED' ||
  // ordStatus === 'DELIVERED'

  const [pingCount, setPingCount] = useState(0);
  const [feedbackSubmit, setFeedbackSubmit] = useState(false);
  const context = useContext(Context);
  const [statusLoader, setStatusLoader] = useState(false);
  const [feedbackAccordState, setFeedbackAccordState] = useState(false);
  const [ordStatus, setOrdStatus] = useState('');
  const setAccordionStatus = () => {
    setFeedbackAccordState(!feedbackAccordState);
  };

  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const orderModes = useSelector((state) => selectOrderModesByCountry(state, country));
  const [stateOpen, setStateOpen] = useState(false);
  const [purchaseEvent, setPurchaseEvent] = useState(false);
  const [sentFeedback, setSentFeedback] = useState(true);
  const [feedThankyouPop, setFeedThankyouPop] = useState(false);
  const [smileIndex, setSmileIndex] = useState(0);
  let rateArray = JSON.parse(window.localStorage.getItem('_fed')) || [];
  const [isPreviousFeedbackAvailable, setIsPreviousFeedbackAvailable] = useState(false);
  const [hideRating, setHideRating] = useState(false);
  const [showthanksPop, setShowthanksPop] = useState(false);
  const [showThankyou, setShowThankyou] = useState(false);
  useEffect(() => {
    if (rateArray.includes(orderInfo?._id)) {
      setIsPreviousFeedbackAvailable((prev) => true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderInfo?._id, hideRating, sentFeedback, rateArray]);
  const changeDrawerStatus = () => {
    setStateOpen(false);
  };
  const changeThankYou = () => {
    setFeedThankyouPop((prev) => !prev);
  };
  const currentUser = useSelector(getCurrentProfile);

  const isDesktop = useSelector(selectDesktop);
  const labelVeriable = `ORDER_${ordStatus}`;

  const [refreshStatus, setRefreshStatus] = useState(false);
  const getOrderStatusDetails = () => {
    setRefreshStatus(true);
    setStatusLoader(true);
    dispatch(getOrderDetail({ orderId })).then((resp) => {
      setOrderInfo((prev) => resp?.payload?.data?.data);
    });
    dispatch(orderStatus({ orderId: orderId })).then((resp) => {
      setOrdStatus((prev) => resp?.payload?.data?.data?.status);
      setStatusLoader(false);
      setRefreshStatus(false);
    });
  };
  useEffect(() => {
    if (orderInfo) {
      // setIsPreviousFeedbackAvailable(!!localStorage.getItem(`${orderInfo._id}_feedback`));
      if (orderInfo.status !== 'FAILURE') {
        window.localStorage.setItem('_PMI', orderInfo?.payment?.paymentMethodId);
        window.localStorage.setItem('_MPS', orderInfo?.payment?.paymentMethodSource);
      }
    }
  }, [orderInfo]);
  useEffect(() => {
    if (isLogged !== null && !isLogged) {
      navigate(`/${context.locale}/home`, { replace: true });
    }
  }, [context.locale, isLogged, navigate]);
  useEffect(() => {
    if (cartDetail?.data?.items?.length && cartDetail?.data?.items?.length > 0) {
      dispatch(clearCart());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartDetail]);
  useEffect(() => {
    if (showThankyou) {
      setShowthanksPop((prev) => true);
    }
  }, [showThankyou]);
  useEffect(() => {
    let myArray = JSON.parse(window.localStorage.getItem('_ord')) || [];
    if (
      orderInfo?.payment?.paymentMethodGroupId !== 100 &&
      !purchaseEvent &&
      orderInfo?.payment?.retry?.[0]?.state === 'AUTHORIZE' &&
      !myArray.includes(orderInfo?._id)
    ) {
      myArray.push(orderInfo?._id);
      if (myArray.length > 5) {
        myArray.shift();
      }
      setPurchaseEvent((prev) => true);
      purchaseEventGA(
        countryValidations?.currency,
        orderInfo,
        orderInfo?.orderType,
        categoryList,
        offerSelected,
        orderInfo?._id,
        orderInfo?.payment.paymentMethodId
      );
      if (orderInfo?.appliedBinPromo?.discountAmount) {
        binThankyou('CouponApplied', orderInfo?.appliedBinPromo?.discountAmount?.amount);
      }
      window.localStorage.setItem('_ord', JSON.stringify(myArray));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryList, offerSelected, ordStatus, orderInfo, purchaseEvent]);
  useEffect(() => {
    if (ordStatus === 'READY') {
      trackingPurchaseGA(orderInfo, offerSelected, categoryList, countryValidations?.currency);
    }
  }, [categoryList, countryValidations.currency, offerSelected, ordStatus, orderInfo]);
  const createDate = new Date(orderInfo?.createdAt) || 0;
  const newDate = new Date();
  const differenceTime = differenceInMinutes(
    new Date(
      newDate.getFullYear(),
      newDate.getMonth(),
      newDate.getDate(),
      newDate.getHours(),
      newDate.getMinutes(),
      0
    ),
    new Date(
      createDate.getFullYear(),
      createDate.getMonth(),
      createDate.getDate(),
      createDate.getHours(),
      createDate.getMinutes(),
      0
    )
  );

  let enableState = differenceTime === 'NaN' ? false : differenceTime < 15 ? true : false;
  if (orderInfo?.advanceTime !== 0) {
    enableState = true;
  }

  useEffect(() => {
    if (profile.status === 'succeeded' && isLogged && cartDetail.status === 'succeeded') {
      if (pingCount === 0) {
        setStatusLoader(true);
        dispatch(getOrderDetail({ orderId })).then((resp) => {
          if (resp.error) {
            navigate(`/${intl.locale}/home`);
          } else {
            resp?.payload?.data?.data && setOrderInfo((prev) => resp?.payload?.data?.data);
          }
        });
        dispatch(orderStatus({ orderId: orderId })).then((resp) => {
          resp?.payload?.data?.data && setOrdStatus((prev) => resp?.payload?.data?.data?.status);
        });
        setStatusLoader(false);
      }
      if (pingCount < 20) {
        const interval = setTimeout(() => {
          if (pingCount < 20 && ordStatus === 'PENDING') {
            setStatusLoader(true);
            dispatch(getOrderDetail({ orderId })).then((resp) => {
              resp?.payload?.data?.data && setOrderInfo((prev) => resp?.payload?.data?.data);
            });
            dispatch(orderStatus({ orderId: orderId })).then((resp) => {
              resp?.payload?.data?.data &&
                setOrdStatus((prev) => resp?.payload?.data?.data?.status);
              setStatusLoader(false);
            });
            setRefreshStatus(false);
          } else {
            clearTimeout(interval);
          }
          setPingCount((prev) => prev + 1);
        }, 15000);

        return () => clearTimeout(interval);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pingCount, refreshStatus, ordStatus, cartDetail.status, profile.status]);
  React.useEffect(() => {
    if (
      orderInfo?.country &&
      profile.status === 'succeeded' &&
      profile.country !== orderInfo?.country
    ) {
      navigate(`/${intl.locale}/home`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderInfo, profile?.country, profile?.status]);
  const trackOrder = (path) => {
    navigate(`/${context.locale}/track-order/` + path);
    if (orderInfo.uOrderRef) {
      orderTrackGA(orderInfo.uOrderRef, 'ThankYouPage');
    }
  };
  useEffect(() => {
    if (!sentFeedback) {
      changeThankYou();
    }
  }, [sentFeedback]);
  const submitStarRating = (index) => {
    const payload = {
      rating: index,
      mdbOrderId: orderInfo._id || '',
    };
    // let rateArray = JSON.parse(window.localStorage.getItem('_fed')) || [];
    // rateArray.push(orderInfo._id);
    // if (rateArray.length > 5) {
    //   rateArray.shift();
    // }
    // window.localStorage.setItem('_fed', JSON.stringify(rateArray));
    // setHideRating((prev) => true);
    // setIsPreviousFeedbackAvailable(true);

    setSmileIndex(index + 1);
    setStateOpen(true);
  };
  const Icon = orderModes.find((val) => val.type === orderInfo?.address?.addressSubType)?.imageAlt;
  const orderIcon = phIcon;
  const enableFeedback =
    ((ordStatus !== 'DELIVERED' || ordStatus === 'FAILURE' || ordStatus === 'CANCELED') &&
      (ordStatus !== 'PENDING' || (!enableState && ordStatus === 'PENDING'))) ||
    orderInfo?.advanceTime !== 0
      ? true
      : false;
  const storeNameLang = 'name_' + context.locale;
  const addressString = `address_${context.locale}`;
  React.useEffect(() => {
    if (
      localStorage.getItem('saveForFuture') === 'false' ||
      localStorage.getItem('saveForFuture') === undefined
    ) {
      localStorage.setItem('cookingValue', '');
      dispatch(removeCookieData);
    }
    Object.values(storeList || {}).every((val) => {
      if (val.storeId === orderInfo?.store?.storeId) {
        setSelectedStore(val);
        return false;
      }
      return true;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderInfo]);

  const curbsideCardData = [
    {
      step: intl.formatMessage({ id: 'curbSide_step1' }),
      image: map1,
      text: intl.formatMessage({ id: 'curbSide_step1Desc' }),
    },
    {
      step: intl.formatMessage({ id: 'curbSide_step2' }),
      image: parking,
      text: intl.formatMessage({ id: 'curbSide_step2Desc' }),
    },
    {
      step: intl.formatMessage({ id: 'curbSide_step3' }),
      image: chat,
      text: intl.formatMessage(
        { id: 'curbSide_step3Desc' },
        { icon: <img src={phn} alt="Phone Icon" /> }
      ),
    },
    {
      step: intl.formatMessage({ id: 'curbSide_step4' }),
      image: phoneIcon,
      text: intl.formatMessage({ id: 'curbSide_step4Desc' }),
    },
    {
      step: intl.formatMessage({ id: 'curbSide_step5' }),
      image: delivery,
      text: intl.formatMessage({ id: 'curbSide_step5Desc' }),
    },
  ];

  const CurbsideCards = () => {
    return (
      <>
        <div className={css.cardsContainer}>
          {curbsideCardData.map((card, index) => (
            <div key={index} className={css.card}>
              <span className={css.step}>{card.step}</span>
              <img className={css.image} src={card.image} alt="Card Image" />
              <span className={css.text}>{card.text}</span>
            </div>
          ))}
        </div>
      </>
    );
  };

  const MessageBox = () => {
    let title = '';
    let content = '';
    if (ordStatus == 'FAILURE') {
      title = intl.formatMessage({ id: 'refund_initiate' });
      content = (
        <p className={css.messageContent}>
          <FormattedMessage id={'refund_of'} />
          <span className={css.bold}>
            {` ${decimalChecker(orderInfo?.payment?.amount)} ${countryValidations?.currency} `}
          </span>
          <FormattedMessage id={'payment_reflect'} />
        </p>
      );
    } else if (ordStatus == 'CANCELED') {
      title = '';
      content = (
        <p className={css.messageContent}>
          <FormattedMessage id={'refund_time'} />
        </p>
      );
    } else if (ordStatus == 'PENDING' && !enableState) {
      title = '';
      content = (
        <p className={css.messageContent}>
          <FormattedMessage
            id={'payment_initiate'}
            values={{
              price: decimalChecker(orderInfo?.payment?.amount),
              currency: countryValidations?.currency,
            }}
          />
        </p>
      );
    }

    return (
      <Grid className={css.messageBox}>
        <p className={css.messageTitle}>{title}</p>
        {content}
      </Grid>
    );
  };

  const renderThankyouPage = () => {
    if (ordStatus === '') {
      return <Skelton />;
    } else {
      return (
        <>
          <div className={css.thankyouTitle}>
            <FormattedMessage id="order_status" defaultMessage="Order Status" />
          </div>
          {isDesktop && <Divider />}
          <Grid className={isDesktop ? css.desktopContainer : css.container}>
            <Grid className={css.firstContainer}>
              {(ordStatus !== 'FAILURE' || ordStatus !== 'CANCELED') && (
                <>
                  <Paper square className={css.statusField}>
                    {ordStatus === 'READY' ? (
                      <>
                        <OrderStatus
                          isDesktop={isDesktop}
                          statusLoader={statusLoader}
                          ordStatus={ordStatus}
                          title={labels?.['ORDER_PREPARED'].title}
                          description={labels?.['ORDER_PREPARED'].description}
                          orderInfo={orderInfo}
                          img={orderIcon}
                          country={country}
                          enableState={enableState}
                          differenceTime={differenceTime}
                        />
                      </>
                    ) : (
                      <OrderStatus
                        isDesktop={isDesktop}
                        getOrderStatusDetails={getOrderStatusDetails}
                        statusLoader={statusLoader}
                        ordStatus={ordStatus}
                        title={labels?.[labelVeriable]?.title}
                        description={labels?.[labelVeriable]?.description}
                        orderInfo={orderInfo}
                        img={orderIcon}
                        country={country}
                        enableState={enableState}
                        differenceTime={differenceTime}
                      />
                    )}
                    {refreshStatus && (
                      <LinearProgress style={{ color: '#e4002b', backgroundColor: '#ffffff' }} />
                    )}
                  </Paper>
                </>
              )}
              {(!enableState && ordStatus === 'PENDING') || ordStatus === 'CANCELED' ? (
                ''
              ) : (
                <>
                  {(orderInfo?.address?.addressSubType === 'CURBSIDE' ||
                    orderInfo?.address?.addressSubType === 'CARHOP') &&
                    ordStatus != 'FAILURE' &&
                    orderInfo?.advanceTime === 0 && (
                      <Grid
                        className={
                          ordStatus === 'PENDING' ||
                          ordStatus === 'CANCELED' ||
                          ordStatus === 'DELIVERED'
                            ? css.disableGrid
                            : css.enableGrid
                        }
                      >
                        <CurbsideCards />
                      </Grid>
                    )}
                  {/* {!(!isDesktop && ordStatus == 'FAILURE') && ( */}
                  {ordStatus !== 'FAILURE' && (
                    <Paper className={css.trackOrder}>
                      <Grid
                        className={
                          (ordStatus === 'PENDING' && orderInfo?.advanceTime === 0) ||
                          ordStatus === 'CANCELED' ||
                          ordStatus === 'DELIVERED'
                            ? css.disableGrid
                            : css.enableGrid
                        }
                        onClick={() => trackOrder(orderInfo._id)}
                      >
                        <Grid>
                          <img src={locatinIcon} alt="" />
                          <Typography>
                            <FormattedMessage
                              id="navigation_trackOrder"
                              defaultMessage="Track Order"
                            />
                          </Typography>
                        </Grid>
                        <Grid className={css.forwardArrow}>
                          <AiOutlineRight />
                        </Grid>
                      </Grid>
                    </Paper>
                  )}
                </>
              )}
              {ordStatus === 'FAILURE' ||
              ordStatus === 'CANCELED' ||
              (!enableState && ordStatus === 'PENDING') ? (
                ''
              ) : (
                <>
                  {!isDesktop && (
                    <Paper className={css.orderSumeryValue}>
                      <OrderSummary
                        paymentCompleted={paymentCompleted}
                        enableState={enableState}
                        orderInfo={orderInfo}
                        ordStatus={ordStatus}
                        isDesktop={isDesktop}
                      />
                    </Paper>
                  )}
                </>
              )}
              {orderInfo?.address?.addressSubType === 'DELIVERY' && (
                <Paper
                  className={classNames(css.restInfoContainer, {
                    [css.disableGrid]:
                      ordStatus === 'PENDING' || ordStatus === 'DELIVERED' || enableState,
                    [css.enableGrid]:
                      (ordStatus !== 'PENDING' && ordStatus !== 'DELIVERED') || !enableState,
                  })}
                >
                  <Grid item className={css.restIcon}>
                    <img src={LocationPin} />
                  </Grid>
                  <Grid item className={css.restraContainer}>
                    <Grid className={css.header1}>
                      <Typography>
                        <FormattedMessage id={'pizzahut_store'} defaultMessage={'Pizzahut Store'} />
                      </Typography>
                      {((ordStatus !== 'PENDING' && ordStatus !== 'DELIVERED') || !enableState) && (
                        <Link href={`tel:${countryValidations?.customerCare}`}>
                          <img src={supportPhone} />
                        </Link>
                      )}
                    </Grid>
                    {(ordStatus === 'PENDING' || ordStatus === 'DELIVERED') && enableState ? (
                      <Skeleton
                        count={2}
                        height={'.9rem'}
                        style={{ marginBottom: '.5rem', marginTop: '.5rem' }}
                      />
                    ) : (
                      <>
                        <Grid>
                          <Typography className={css.header}>
                            {selectedStore[storeNameLang]}
                          </Typography>
                        </Grid>
                        <Grid className={css.descContainer}>
                          <Grid>
                            <Typography className={css.restaudesc}>
                              {selectedStore[addressString]}
                            </Typography>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Paper>
              )}

              {!isPreviousFeedbackAvailable &&
                sentFeedback &&
                !(!isDesktop && ordStatus == 'FAILURE') && (
                  <Paper className={css.feedbackArea}>
                    <Grid className={!enableFeedback && css.disableGrid}>
                      <StarRating submitStarRating={submitStarRating} />
                    </Grid>
                  </Paper>
                )}
            </Grid>

            {!isDesktop && ordStatus == 'FAILURE' && (
              <>
                <Paper className={css.failedMessage}>
                  <UnableProcess
                    orderInfo={orderInfo}
                    ordStatus={ordStatus}
                    enableState={enableState}
                  />
                  <MessageBox />
                </Paper>
                <Paper className={css.failedMessage}>
                  <Writeus email={countryValidations?.supportEmail} />
                </Paper>
              </>
            )}

            <Grid className={isDesktop ? css.desktopGrid2 : css.mobileGrid2}>
              {isDesktop && (
                <>
                  {/* {!enableState && ordStatus === 'PENDING' ? (
                    ''
                  ) : ( */}
                  <Paper>
                    <OrderSummary
                      orderInfo={orderInfo}
                      ordStatus={ordStatus}
                      enableState={enableState}
                      paymentCompleted={paymentCompleted}
                      isDesktop={isDesktop}
                    />
                  </Paper>
                  {/* )} */}
                </>
              )}
            </Grid>
            <DialogBox hideCloseButton size="sm" isOpen={lightningPayStatusModal}>
              <LightningPayStatus
                onClose={() => {
                  setLightningPayStatusModal(false);
                  navigate(`/${context.locale}/thank-you/${orderId}`, { replace: true });
                }}
                success={true}
              />
            </DialogBox>
          </Grid>
        </>
      );
    }
  };
  const refreshButton = () => {
    return (
      !isDesktop &&
      ordStatus === 'PENDING' && (
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          onClick={() => getOrderStatusDetails()}
        >
          <FormattedMessage id="refresh" defaultMessage="Refresh" />
        </Button>
      )
    );
  };

  return (
    <div className={css.root}>
      <Header
        icon={
          <Button
            className={css.homeIcon}
            variant="outlined"
            // color="secondery"
            disableRipple
            size="medium"
            onClick={() => navigate('/home')}
          >
            <RiHome3Line />
          </Button>
        }
        title={<FormattedMessage id="order_status" defaultMessage="Order Status" />}
        actionButtons={[<LanguageButton />, refreshButton()]}
      />
      {renderThankyouPage()}
      {!isDesktop && (
        <DrawerPwa
          hideCloseButton={true}
          variant="temporary"
          anchor="bottom"
          open={stateOpen}
          onClose={changeDrawerStatus}
        >
          <FeedbackInfo
            setShowThankyou={setShowThankyou}
            ordrId={orderId}
            sentFeedback={setSentFeedback}
            submitStarRating={submitStarRating}
            onDrawerHandling={changeDrawerStatus}
            smileIndex={smileIndex}
          />
        </DrawerPwa>
      )}
      {isDesktop && (
        <DialogBox isOpen={stateOpen} onClose={changeDrawerStatus} hideCloseButton={true}>
          <FeedbackInfo
            setShowThankyou={setShowThankyou}
            ordrId={orderId}
            sentFeedback={setSentFeedback}
            submitStarRating={submitStarRating}
            onDrawerHandling={changeDrawerStatus}
            smileIndex={smileIndex}
          />
        </DialogBox>
      )}
      {/* {!isDesktop && (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={feedThankyouPop}
          onClose={changeThankYou}
          hideCloseButton={true}
        >
          <FeedbackPopup
            showThankyou={showThankyou}
            ordrId={orderId}
            onDrawerHandling={changeThankYou}
            submitStarRating={submitStarRating}
            smileIndex={smileIndex}
          />
        </DrawerPwa>
      )}
      {isDesktop && (
        <DialogBox isOpen={feedThankyouPop} onClose={changeThankYou} hideCloseButton={true}>
          <FeedbackPopup
            showThankyou={showThankyou}
            ordrId={orderId}
            onDrawerHandling={changeThankYou}
            submitStarRating={submitStarRating}
            smileIndex={smileIndex}
          />
        </DialogBox>
      )} */}

      {!isDesktop && showthanksPop && (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={showthanksPop}
          onClose={() => setShowthanksPop(false)}
          hideCloseButton={true}
        >
          <FeedbackPopup
            showThankyou={showThankyou}
            ordrId={orderId}
            onDrawerHandling={() => setShowthanksPop(false)}
            submitStarRating={submitStarRating}
            smileIndex={smileIndex}
          />
        </DrawerPwa>
      )}
      {isDesktop && showthanksPop && (
        <DialogBox
          isOpen={feedThankyouPop}
          onClose={() => setShowthanksPop(false)}
          hideCloseButton={true}
        >
          <FeedbackPopup
            showThankyou={showthanksPop}
            ordrId={orderId}
            onDrawerHandling={() => setShowthanksPop(false)}
            submitStarRating={submitStarRating}
            smileIndex={smileIndex}
          />
        </DialogBox>
      )}
      <footer className={css.footer}></footer>
    </div>
  );
}

export default Thankyou;
